<template>
  <div class="gs-price-point-groups">
    <div class="gs-price-point-groups__pinned">
      <template v-for="entry in groups.pinned">
        <slot :price-point="entry.pricePoint" :index="entry.index"></slot>
      </template>
    </div>
    <template v-if="groups.more.length">
      <div class="gs-price-point-groups__divider">
        <button type="button" class="gs-price-point-groups__toggle" :aria-expanded="expanded ? 'true' : 'false'" @click="expanded = !expanded">
          <gs-icon :name="expanded ? 'chevron-up' : 'chevron-down'" size="16"></gs-icon>
          <span>More price points ({{ groups.more.length }})</span>
        </button>
        <small>All price points stay live for customers.</small>
      </div>
      <div v-if="expanded" class="gs-price-point-groups__more">
        <template v-for="entry in groups.more">
          <slot :price-point="entry.pricePoint" :index="entry.index"></slot>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { groupPricePoints } from '../pricePointGroups';

export default {
  name: 'PricePointGroups',
  props: { pricePoints: { type: Array, default: () => [] } },
  data() { return { expanded: false }; },
  computed: { groups() { return groupPricePoints(this.pricePoints); } },
};
</script>

<style>
/* Keep the host step's own flex/grid gaps between rows: the wrappers are structural only. */
.gs-price-point-groups,
.gs-price-point-groups__pinned,
.gs-price-point-groups__more { display: contents; }
.gs-price-point-groups__divider { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin: 14px 0; padding: 10px 14px; border: 1px dashed var(--gs-border-strong, #cbd5e1); border-radius: var(--gs-radius-md, 10px); background: var(--gs-surface-subtle, #f8fafc); }
.gs-price-point-groups__toggle { display: inline-flex; align-items: center; gap: 8px; padding: 0; color: var(--gs-foreground, #182230); font-size: 14px; font-weight: 650; background: transparent; border: 0; cursor: pointer; }
.gs-price-point-groups__divider small { color: var(--gs-muted-foreground, #667085); font-size: 12px; }
</style>
